import { render, staticRenderFns } from "./ColorPalette.vue?vue&type=template&id=42f6f58b&scoped=true&"
import script from "./ColorPalette.vue?vue&type=script&lang=js&"
export * from "./ColorPalette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f6f58b",
  null
  
)

export default component.exports